<template>
  <element>
    <nav-breadcrumb :menu="[{label: '意向进件'}, {label: '意向进件详情'}]"/>

    <el-row>
      <el-col class="grid-content bg-purple">
        <el-steps :active="1000" class="step-shenpi">
          <el-step :title="'客户送审'"  :description="$moment((customerDetail.t__applicationDate||{})).format('YYYY-MM-DD HH:mm:ss')">
            <i class="step-start" slot="icon"></i>
          </el-step>

          <el-step v-for="(item, idx) in (customerDetail.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
              <i class="step-mid" slot="icon" v-if="item.a__approvalType!='reStart'"></i>
              <div  v-if="item.a__approvalType!='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} <br />{{item.a__approverName}}</div>
              <i class="step-start" slot="icon" v-if="item.a__approvalType=='reStart'"></i>
              <div  v-if="item.a__approvalType=='reStart'" slot="title">{{Status2CN(item.a__nodeName)}}</div>
          </el-step>

          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Approved'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Completed'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
        </el-steps>
      </el-col>
    </el-row>

    <el-row>
      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <customer-detail-fang-component v-model="customerDetail"/>
            </el-tab-pane>
            <el-tab-pane label="抵押房屋" name="House">
              <customer-house-fang-component v-model="customerDetail"/>
            </el-tab-pane>
          </template>
          <el-tab-pane label="共借人" name="borrower">
            <panel v-for="(item, idx) in customerDetail.coborrowers" :key="idx">
              <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled v-if="item.co__checked"></el-checkbox>
              <panel class="zhengjianxinxi"   v-if="item.co__checked">
              <form-build
                :form-data.sync="item"
                :form-rules="coRules"
                :form-columns="coColumns"
                class="formTable"

              />
              </panel>
              <panel class="zhengjianxinxi"  v-if="item.co__checked">
              <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面"/>
              <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面"/>
              <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
              </panel>
            </panel>
          </el-tab-pane>
          <el-tab-pane  label="收款银行账户" name="bank">
            <panel class="zhengjianxinxi">
              <form-build
                :form-data.sync="customerDetail"
                :form-rules="bankRules"
                :form-columns="bankColumns"
                class="formTable"
                form-name="formSubmit4" ref="formBuildName4"
              />
            </panel>
            <panel class="zhengjianxinxi">
              <photo-browser v-model="customerDetail.pic__customerBankCardFront" type='image' label="银行卡正面"/>
            </panel>
          </el-tab-pane>
        </el-tabs>
        <panel label="审核流程">
          <data-table
            :table-data="{data: customerDetail.approvals||[]}"
            :columns="approvalTableColumns"
            :is-pagination-show="false"
          />
        </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button @click="$router.back()">返回</el-button>
    </div>
    </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import CustomerDetailFangComponent from '../components/CustomerDetailFangComponent'
  import CustomerHouseFangComponent from '../components/CustomerHouseFangComponent'
    export default {
        name: "CustomerApplyingApproveKF",
      components: {Panel},
      data(){
          return {
            bankRules: {
            },
            bankColumns:[
              {
                label: '户名',
                field: 'ba__customerName',
                type: 'text',
              },
              {
                label: '账号',
                field: 'ba__customerBankAccountNo',
              },
              {
                label: '开户银行',
                field: 'ba__customerBankName',
                span:24
              },
            ],
            coRules:{

            },
            coColumns:[
              {
                label: '与借款人关系',
                field: 'co__relationship',
              },
              {
                label: '姓名',
                field: 'co__borrowerName',
              },
              {
                label: '身份证号码',
                field: 'co__borrowerIC',
              },
              {
                label: '手机号',
                field: 'co__borrowerContactNo',
              },
              {
                label: '住所地址',
                field: 'co__borrowerAddress',
                span:24
              },
            ],
            tabName: 'CustomerSummary',
            applicationId: this.$route.query['applicationId']||'',
            customerDetail:{
              approvals:[],
              coborrowers:[]
            },
            customerColumns: [
              {
                label: '身份证号码',
                field: 'ba__customerIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '客户姓名',
                field: 'ba__customerName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '性别',
                field: 'ex__customerSex',
                component: 'el-select',
                options:[
                  {
                    label:'男',
                    value:'M'
                  },
                  {
                    label:'女',
                    value:'F'
                  }
                ],

              },


              {
                label: '手机号',
                field: 'ba__customerContactNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '出生日期',
                field: 'ex__customerDOB',
                component: 'el-date-picker',
                valueFormat: 'yyyy-MM-dd',
              },

              {
                label: '户口地区',
                field: 'ex__customerHukou',
                component: 'el-input',
                type: 'text',
              },

              {
                label: '籍贯',
                field: 'ex__customerJiguan',
                component: 'el-input',
                type: 'text',
                span:24
              },
              {
                label: '常住地址',
                field: 'ex__customerAddress',
                component: 'el-input',
                span:24
              },

              {
                label: '婚姻状况',
                field: 'ex__customerMartialStatus',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '配偶姓名',
                field: 'ex__spouseName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '配偶身份证号码',
                field: 'ex__spouseIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '配偶手机',
                field: 'ex__spouseContactNo',
                component: 'el-input',
                type: 'text',
              },

              {
                label: '申贷金额',
                field: 'ba__amount',
                component: 'el-input',
                type: 'text',
                span:12
              },
              {
                label: '',
                field: '',
                span:12
              },
              {
                label: '客户来源',
                field: 'ba__channel',
              },

              {
                label: '分配渠道商',
                field: 'd__dealerName'
              },
              {
                label: '进件人',
                field: 'jinjian__userName'
              },
              {
                label: '渠道商审核人员',
                field: 'chushen__userName'
              },


            ],
            houseColumns:[
              {
                label: '权属',
                field: 'ex__propertyOwner',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '位置',
                field: 'ex__propertyLocation',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '用途',
                field: 'ex__propertyUsage',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '面积',
                field: 'ex__propertyArea',
                component: 'el-input',
                type: 'number',
                props: {
                  step: 0.01
                },
                unit:'㎡'
              },
              {
                label: '产权证号',
                field: 'ex__propertyCertNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '土地证',
                field: 'ex__propertyLandNo',
                component: 'el-input',
                type: 'text',
              },
            ],
            asmColumns:[
              {
                label: '评估单价',
                field: 'asm__assessedUnitValue',
                component: 'el-input',
                type: 'number',
                unit:'元/㎡'
              },
              {
                label: '实际评估价',
                field: 'asm__assessedTotalValue',
                component: 'el-input',
                type: 'number',
                unit:'元'
              },
              {
                label: '核定贷款金额',
                field: 'asm__approvedAmount',
                component: 'el-input',
                type: 'number',
                unit:'元'
              },
              {
                label: '抵押率',
                field: 'asm__pledgeRate',
                component: 'el-input',
                type: 'number',
                unit:'%'
              },
              {
                label: '抵押顺位',
                field: 'asm__pledgeGrade',
                component: 'el-input',
                type: 'text',
                span:24

              },
              {
                label: '产调情况',
                field: 'asm__pledgeRemarks',
                component: 'el-input',
                type: 'textarea',
                span:24

              },
              {
                label: '其他资产情况',
                field: 'asm__otherAssets',
                component: 'el-input',
                type: 'textarea',
                span:24

              },
              {
                label: '网络核查情况',
                field: 'asm__internetCheck',
                component: 'el-input',
                type: 'textarea',
                span:24

              },
              {
                label: '评估情况',
                field: 'asm__accessmentRemarks',
                component: 'el-input',
                type: 'textarea',
                span:24

              },
              {
                label: '结论',
                field: 'asm__accessmentResult',
                component: 'el-input',
                type: 'textarea',
                span:24

              },
              {
                label: '审核意见',
                field: 'a__remarks',
                component: 'el-input',
                type: 'textarea',
                span:24

              },

            ],
            customerRules:{},
            page: 1,
            pageSize: 20,
            actions: [
              {
                label: '新增',
                class: 'el-button--primary',
                clickHandler: ()=>{
                  this.tableData.data.push({})
                }
              }
            ],
            filters: {
              form: {

              },
              columns: [

              ]
            },
            tableData :{
              count: 0,
              data: [
                {
                  pv__ckecked:'true',
                  pv__source:'',
                  pv__quote: '',
                },
              ]
            },
            columns:[
              {
                label: '序号',
                type: 'index'
              },
              {
                label: '查询渠道',
                field: 'pv__source',
                component: 'el-input',
                type: 'text',
              },{
                label: '挂牌单价',
                field: 'pv__quote',
                component: 'el-input',
                type: 'number',
                unit:'元/㎡'
              },

            ],
            approvalTableColumns: [
              {
                label: '节点',
                field: 'a__nodeName',
                formatter: (r,c,v)=> {
                  return Status2CN(v)
                }
              },
              {
                label: '操作人',
                field: 'a__approverName'
              },
              {
                label: '操作时间',
                field: 'a__approvingDate',
                formatter: (r,c,v)=>{
                  if(v)
                  return moment(v).format('YYYY-MM-DD HH:mm:ss')
                }
              },
              {
                label: '操作结果',
                field: 'a__approvingStatus',
                formatter: (r,c,v)=> {
                  return Status2CN(v)
                }
              },
              {
                label: '操作备注',
                field: 'a__remarks'
              }
            ]
          }
        },
      components: {
        CustomerDetailFangComponent,
        CustomerHouseFangComponent,
      },
      mounted() {
          this.getApplyingCustomerFang()
      },
      methods: {
          Status2CN,
          getApplyingCustomerFang : function () {
            xhr.getApplyingCustomerFang({
              't.applicationId': this.$route.query['applicationId']
            }, res=>{
              try{
                if(res.data.status == 'success') {
                  this.customerDetail = res.data.data
                  this.tableData.data = this.customerDetail.values
                  let interestType =  this.customerDetail.ba__interestType
                   let unit = ''
                   this.customerDetail.interestType
                   if(interestType=='Yearly'){
                     unit="%（年利率）"
                   }
                   if(interestType=='Daily'){
                     unit="%（日利率）"
                   }
                   if(interestType=='Monthly'){
                     unit="%（月利率）"
                   }
                   this.customerDetail.interestType = this.customerDetail.ba__interestRate + unit
                    let approvals = []
                    for(var i=0;i<this.customerDetail.approvals.length;i++){
                        approvals.push(this.customerDetail.approvals[i])
                        if(this.customerDetail.approvals[i].a__approvalType=='ZJL'&&this.customerDetail.approvals[i].a__approvingStatus=='Approved'&&i<this.customerDetail.approvals.length-1){
                            approvals.push({
                                'a__nodeName':'reStart',
                                'a__approvingDate':this.customerDetail.approvals[i].a__approvingDate,
                                'a__approvingStatus':''
                            })
                        }
                    }
                    this.customerDetail.approvals = approvals
                }
              }catch(e){}
            })
          },
        onSubmit :function (status) {
          this.customerDetail.values = this.tableData.data
          this.customerDetail.a__approvingStatus = status
          this.customerDetail.values.forEach(item=>{
            item.detail__checked = true
            item.pv__checked = true
          })
          xhr.updateApproveCustomerFangEdit(
            this.customerDetail,
            res=> {
              try{
                if(res.data.status == 'success') {

                }else{

                  this.$message.error(res.data.msgs[0].text)
                }
                this.$router.push({
                  path: 'List'
                })
              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingDetail.vue